<template>
  <div v-if="store.itemCount === 0">
    Handlekurven er tom.
    <div class="flex flex-col space-y-4 mt-4">
      <UButton block v-if="config.public.canOrderDomain" to="/domene/sok"
        >Søk etter domene</UButton
      >
      <UButton block v-if="config.public.canOrderCloudServer" to="/cloud-server"
        >Legg til Cloud Server</UButton
      >
    </div>
  </div>
  <div v-else class="flex flex-col space-y-4">
    <ShoppingCartDomainList />

    <ShoppingCartMicrosoft365List />

    <ShoppingCartServerList />
  </div>
</template>

<script lang="ts" setup>
const store = useCartStore();
const config = useRuntimeConfig();
</script>

<style></style>
